import _, { compose, partial } from 'underscore';
import { withProps } from '@bingads-webui-react/with-props';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { propertyIs, StandardControlAdapter } from '@bingads-webui-campaign-react/form-error';
import { ValidatedUrlOptionsParameters } from '@bingads-webui-campaign-react/url-options';

const campaignTrackingUrlTemplate = propertyIs('TrackingUrlTemplate');
const campaignFinalUrlSuffix = propertyIs('FinalUrlSuffix');
const campaignUrlCustomParameters = propertyIs('UrlCustomParameters');
const trackingUrlTemplateControlsWrapper = compose(
  withControlErrorHandling,
  partial(withUnvalidatedControlErrors, _, { filter: campaignTrackingUrlTemplate, Adapter: StandardControlAdapter() })
);
const finalUrlSuffixControlsWrapper = compose(
  withControlErrorHandling,
  partial(withUnvalidatedControlErrors, _, { filter: campaignFinalUrlSuffix, Adapter: StandardControlAdapter() })
);
const urlCustomParametersControlsWrapper = compose(
  withControlErrorHandling,
  partial(withUnvalidatedControlErrors, _, { filter: campaignUrlCustomParameters, Adapter: StandardControlAdapter({ functionsToInject: ['onCustomParameterKeyChange', 'onCustomParameterValueChange', 'onRemoveUrlParameter', 'onAddUrlParameter'] }) })
);

export const ServerValidatedUrlOptionsParameters = withControlErrorHandling(withProps({
  trackingUrlTemplateControlsWrapper,
  finalUrlSuffixControlsWrapper,
  urlCustomParametersControlsWrapper,
}, ValidatedUrlOptionsParameters));
